import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FolderIcon from '@mui/icons-material/Folder';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import Tooltip from '@mui/material/Tooltip';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ClearIcon from '@mui/icons-material/Clear';
import { styled } from '@mui/system';
// import { styled } from '@mui/material/styles';
import KsrgrButton from './KsrgrButton'

import { useHref } from "react-router-dom";

import ImageMapper from 'react-img-mapper';
import type { MapArea, RefProperties } from 'react-img-mapper';

import { FunctionComponent, useEffect, useState } from 'react'
import useLocalStorageState ,{LocalStorageState} from 'use-local-storage-state'
import {PrFissesProvider, PrFissesContext, usePrFissescontext} from '../../context/PrFissesContext'
import {PrProduct,PrCartProps,PrCartBrandProps,PrBrandType,PrBrandsIf,PrCartIf} from '../../components/Products'
import { PrCart } from '../../components/Cart';
import { Loader } from '../../components/Loader'
import {useAuth} from '../../context/AuthContext'
import {IPrAvResponseData,IPrAvResponse,IPrOrderResponseData,IPrOrderResponse} from '../PageInterfaces'
// import config from '../../config/'; 
import theme from '../../theme';
import './prfissess.css'
import OutlinedInput from '@mui/material/OutlinedInput';

import {returnBasenameUrl} from '../../utils'
// type UserEvent = Event & {UserId: string}
// type ExtMapArea  = {
//     id: MapArea['id']
//     shape: MapArea['shape']
// }

interface  MyImageAreaType {
    shape: string;
    id: string;
    name: string;
    title: string;
    coords: number[];
    fillColor?:string;
    strokeColor?:string;
    parts?:Object[]
}

type partForBasketType = {
  prcode: string ,
  prname: string ,
  pruom: string ,
  prqty: string
}
export interface SelPartDialogProps {
  open: boolean;
  selectedValue: string;
  onClose: (value: string) => void;
}
interface IPrAvSearch {
  success: boolean,
  prcode: string,
  qty: number,
  data?: IPrAvResponseData
}

function PrFisses() {
  let auth = useAuth();
  // const basename = useHref('/');
  const basename = returnBasenameUrl();

  const fisses = usePrFissescontext().prfissescontextdata
  console.log('PrFisses fisses=',fisses)

  const [pagestate, setPagestate] = React.useState('model-selection') // model-fissa-selection fissa-area-selection
  const [fissamodel, setFissamodel]= React.useState({brand:"",model:""})
  const [modelfisses, setModelfisses]= React.useState<any>(null)  // keeps the fissess object of selected model
  const [fissaImageMap, setFissaImageMap]= React.useState<any>(null)
  const [partsforbasket, setPartsforbasket]= React.useState<partForBasketType[]|null>(null)
  const [openselprsdialog, setOpenselprsdialog] = React.useState(false);
  const [pravqty,setPravqty] = React.useState('1');
  const [prvacode,setPrvacode] = React.useState('');
  const [prcart, setPrCart] = useLocalStorageState<PrCartProps>(`${process.env.REACT_APP_PRCARTKEYNAME}`, {})

  const haClickSelPrsDlgOpen = () => {
    setOpenselprsdialog(true);
  };
  const haSelPrsDlgClose = (value: string) => {
    setOpenselprsdialog(false);
    //setSelectedValue(value);
  };

//   React.useEffect(()=>{
// //     // console.log('PrAvOrd :: useEffect[ getCartLength ]...' )
//     if(getCartLength(prcart)>0) setlockPrCart(true)
// //     else setlockPrCart(false)
//   },[pagestate])

  function backtoModelSelection()
  {
    setFissamodel({brand:"",model:""})
    setModelfisses(null)
    setFissaImageMap(null)
    setPagestate('model-selection')
  }
  function backtoModelFisses()
  {
    // setFissamodel({brand:"",model:""})
    // setModelfisses(null)
    setFissaImageMap(null)
    setPagestate('model-fissa-selection')
  }
  function prepFissesofModel( brand:string, model:string){
    // setFissamodel({brand:item[0], model:item[1]}); setPagestate('model-fissa-selection')}
    const ms = Date.now();
    let basename=returnBasenameUrl()
    let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}&fetch=prfisses&brand=${brand}&model=${model}&appId=${process.env.REACT_APP_APPID}`;
    fetch(url, { method: 'GET' } )
    .then((response) =>  {
        if (!response.ok) {
            console.log('prepFissesofModel:: fetch=prfisses response not ok=',response)
            return {success:false, error:'fetching model fisses, response not ok'}
        }
        else {
            console.log('prepFissesofModel:: setPrfissesContextdata response ok=',response)
            return response.json()
        }
    })
    .then((data:any) => {
      console.log("prepFissesofModel:: fetch=prfisses data=",data); 
      if(data.success===undefined || data.success===null || data.success===false || 
        data.modelfisses===undefined || data.modelfisses===null || data.modelfisses.length<=0
      ){
        console.log("prepFissesofModel:: fetch=prfisses data has errors"); 
      }
      else {
        setModelfisses(data.modelfisses[0]);
        setFissamodel({brand:`${brand}`, model:model}); 
        setPagestate('model-fissa-selection')
        console.log(`prepFissesofModel:: fisses state var 'modelfisses' of ${brand} ${model} is`,data.modelfisses[0])
      }

    })
    .catch((err) => {
      console.log("prepFissesofModel:: fetch=prfisses exception=",err.message);      
    })
    .finally(() => {
      // console.log("PrAFissesProvider finally: ", pravData)            
      // setPrfissesContextdata(prfissesData);                
    })
  }

  function prepFissaImageMap(brand:string, model:string, fissa:any){
    console.log('prepFissaImageMap:: fissa item=',fissa)

    if(fissa[4].length<=0) return;  // no areas yet
    let imgmapurl = ""
    // if(config.originUrl.length>config.baseUrl.length){
    //   imgmapurl = `${basename}/${fissa[2]}`
    // }
    // else {
      imgmapurl = `${basename}/${fissa[2]}` 
    // }
    const fissaid = fissa[0]        // <- "F01"
    const fissatitle = fissa[1]     // <- "Head-light"
    let areasArr: MyImageAreaType[] = [];
    for(var i=0;i<fissa[4].length;i++)
    {
      //  
      let area = fissa[4][i]    // array of areas in image                   
      let startareaid = `${fissaid}-${area.alt['0']}`  // <- F01-1
      /*  "fissesparts": [
        prline :: [
          "F16-20",               // [0]
          "LAVA120",              // [1]
          "101302-517-02B6",      // [2]
          "left rear cover",      // [3]
          "pcs",                  // [4]
          "1"                     // [5]
        ],
        .....
      */
      const aparts = modelfisses.fissesparts.filter( (prline:any) => prline[0].toLowerCase().startsWith(`${startareaid}`.toLowerCase()) )
      let areaid = `${startareaid}`
      let areatitle = ' t? ';
      let areaname = ' n?';
      let areaparts: { areaid: string; prcode: any; prname: any; pruom: any; prqty: any; }[] = []
      if(aparts.length>0){
        areatitle = aparts[0][3]
        areaname = aparts[0][0]
        aparts.forEach( (element:any) => {
          areaparts.push({areaid: areaid, prcode: element[2], prname: element[3], pruom: element[4], prqty: element[5]})
        });
      }
      // {"alt": {"0": "1"}, "shape": { "0": "circle" }, "coords": {"0": "922,162,22"} }
      let scoords = area.coords['0']     // <- "922,162,22"
      let ascoords = scoords.split(",")
      let myImgMapArea: MyImageAreaType={
        shape: area.shape['0'],          // <- "circle" 
        id: areaid,                          // part code
        title: areatitle,                        // part titiel
        name: `${area.alt['0']}`,
        coords:[parseInt(ascoords[0]),parseInt(ascoords[1]),20],
        fillColor: "#ff000026",
        strokeColor: "red",
        parts: areaparts
      }
      areasArr.push(myImgMapArea)
    }
    console.log('imgmapurl',imgmapurl,'fissaid',fissaid,'fissatitle',fissatitle,'areasArr',areasArr)
    console.log('prepFissaImageMap:: fissa areasArr=',areasArr)
    setFissaImageMap({ fissaid: fissaid, fissatitle: fissatitle, imgmapurl: imgmapurl, areas: areasArr })
    setPagestate('fissa-area-selection')
  }

  function setPartsforBasket( area:MyImageAreaType ){
    console.log('selected area for basket',area)
    let arp:any[] = []
    area.parts?.map( (areapart,index)=>{
      let part={
        prcode: ( (areapart as any).prcode) ? (areapart as any).prcode : '' ,
        prname: ( (areapart as any).prname) ? (areapart as any).prname : '' ,
        pruom: ( (areapart as any).pruom) ? (areapart as any).pruom : '' ,
        prqty: ( (areapart as any).prqty) ? (areapart as any).prqty : '' 
      }
      arp.push(part)
    })
    if(arp.length>0) setPartsforbasket(arp)
      else setPartsforbasket(null)
    /*{
  "shape": "circle",
  "id": "F02-3",-
  "title": "Screws-ST4.216",
  "name": "3",
  "coords": [
    102,
    225,
    20
  ],
  "fillColor": "#ff000026",
  "strokeColor": "red",
  "parts": [
    {
      "areaid": "F02-3",
      "prcode": "906114-052",
      "prname": "Screws-ST4.216",
      "pruom": "pcs",
      "prqty": "9"
    }
  ]
}*/
  }

  const haPrAvQtyNumberChange = (event: { target: { value: string } }) => {
    const value = event.target.value.replace(/\D/g, ''); // replace any non digit with empty char
    // const formattedValue = value.replace(/(\d{4})(?=\d)/g, '$1 ');
    if (value.length > 0) {
      setPravqty(value);
    }
  };
  
  function haAddtoBaskettPartClick(part:partForBasketType, prqty:string)
  {
    
    if(auth.userData.success!==true) return
    if(part.prcode===undefined || part.prcode===null || part.prcode === "" || part.prcode.length<=0 ) return
    if(pravqty===undefined || pravqty===null || pravqty === ""|| pravqty.length<=0 ) return
    let token = auth.userData.token
    let usercode = auth.userData.username
    let postdata = {
      service: "getpravinfo", 
      usercode: usercode,
      prcode: part.prcode,
      prqty: pravqty,
      prbrand: "9999",
      markoption: 9999,      
      brandavfilter: 0,
      notbrandavfilter: "200,1000",
      clientid: token
    }
    // let body = `{"service": "getPrAvInfo", "usercode": "${usercode}", "prcode": "${prcode}", "prqty": "${prqty}", "clientid": "${token}"}`
    let body = JSON.stringify(postdata)
    const ms = Date.now();
    let basename=returnBasenameUrl()
    let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
      body: body , cache: "no-store"
   })
    .then((response) =>  {
      if (!response.ok) return {} 
      else return response.json()
    })
    .then((data:any) => {
      console.log(" PrAvOrd fetch Pr AV then ... data=",data)
      const isSuccessPrAvInfoResponse = (data: any): data is IPrAvResponse =>
      typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
      if (isSuccessPrAvInfoResponse(data) && data.success!==true)
      {
        // console.log(" PrAvOrd, fetched data NOT Success PrAvInfoResponse")
        alert('Η ερώτηση διαθεσιμότητας απέτυχε. Προσπαθήστε ξανά σε λίγο (query failed, try again later)')
      }
      else {
        //console.log("data.hasOwnProperty('totalcount')",data.hasOwnProperty('totalcount'),"typeof data.totalcount",typeof data.totalcount)
        if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && typeof data.data === 'object'){
          if( data.totalcount<=0) {
            alert('Η ερώτηση δεν επέστρεψε αποτέλεσμα. Ο κωδικός δεν υπάρχει (query return empty, non existing pr code')
          }
          else {
            let reqqty = parseFloat(pravqty)
            let lineval = reqqty * data.data?.pricer
            let product: PrProduct = {
            id: data.data?.id,
            title: data.data?.name,
            price: data.data?.pricew,
            quantity: reqqty,
            code: data.data?.code,
            code2: data.data?.code2,
            name: data.data?.name,
            name1: data.data?.name1,
            uom: data.data?.uom,
            uomcode: data.data?.uomcode,
            uomname: data?.uomname,
            pricer: data.data?.pricer,
            pricew: data.data?.pricew,
            brand: data.data?.brand,
            brandcode: data.data?.brandcode,
            brandname: data.data?.brandname,
            mtrsup: data.data?.mtrsup,
            info: data.data?.info,
            origin: data.data?.origin,
            remqty: data.data?.remqty,
            ordered: data.data?.ordered,
            reserved: data.data?.reserved,
            avqty: data.data?.avqty,
            reqqty: reqqty,
            lineval: lineval,
            discntperc: 0,
            discntamnt: 0,
            netlineval: 0 ,
            thumbnail: '',
            image: ''     
          }
          setPrCart((prevCart) => {
              const updatedCart = { ...prevCart }
              const productId: string = product.id.toString()
              if (updatedCart[productId]) {
                updatedCart[productId] = { ...updatedCart[productId], 
                  quantity: product.reqqty ,
                  price: product.pricer,
                  reqqty: product.reqqty ,
                  lineval: product.lineval
                }
                return updatedCart
              }
              else {
                return {
                  ...prevCart,
                  [product.id]: product,
                }
            
              }
            })
            console.log(" fetched data Success rows Array set", data)
          }          
        }
        else {
            // console.log(" fetched  data NOT rows Array")
           alert('Η ερώτηση δεν είχε αποτέλεσμα. Ο κωδικός δεν υπάρχει (query return empty, non existing pr code')
        }
      }
    })
    .finally(()=>{haSelPrsDlgClose('close')})
  }

  function haBtnCloseSelPartForBasket()
  {

  }
  const [hoveredArea,setHoveredArea] = React.useState<MapArea|null>(null);
  // const [showtooltip, setShowtooltip ] = React.useState(false);
  // const [tooltipxy, setTooltipxy ] = React.useState({x:0,y:0});
  // const [tooltipname, setTooltipname ] = React.useState("");
  const tooltipRef = React.useRef<HTMLDivElement>(document.createElement('div'));

  const imgmapurl = "https://b2bksrgr.local/images/fiss/model001/E05.gif";
  const imgmapname = "e05";
  const imgareas:MyImageAreaType[] = [
        {"shape":"circle","id":"530400-517B-00","title":"Main footrest assy","name":"12","coords":[66,23,20],"fillColor": "#ff000026","strokeColor": "red"},
        {"shape":"circle","id":"12","name":"name 12","title":"title 12","coords":[111,43,20],"fillColor": "#ff000026","strokeColor": "red"},
        {"shape":"circle","id":"11-2-3","name":"name 11-2-3","title":"title 11-2-3","coords":[169,65,20],"fillColor": "#ff000026","strokeColor": "red"},
        {"shape":"circle","id":"11-2-2","name":"name 11-2-2","title":"title 11-2-2","coords":[206,92,20],"fillColor": "#ff000026","strokeColor": "red"},
        {"shape":"circle","id":"11","name":"name 11","title":"title 11","coords":[271,116,20],"fillColor": "#ff000026","strokeColor": "red"}
    ];

  const ref = React.useRef<RefProperties>(null);
  
  function getTipPosition(area:MapArea) {
        return { top: `${area.coords[1]}px`, left: `${area.coords[0]}px` };
  }
  function enterArea(area:MapArea) {
        setHoveredArea(area );
  }
  function leaveArea() {
        setHoveredArea(  null );
  }
  function getImageAreaData( maparea:MapArea, imageareas:any[]){
      return imageareas.find( function(element) {return element?.id === maparea.id } )
  }
  function getImageTootiptitle( maparea:MapArea, imageareas:any[]){
      const imgarea = imageareas.find( function(element) {return element?.id === maparea.id } )
      if(imgarea){
        return `${(imgarea as MyImageAreaType).name} ${(imgarea as MyImageAreaType).title}`
      }
      else {
        return " ??? "
      }
  }
      // React.useEffect(()=>{
      //   // console.log('PrAvOrd :: useEffect[ getCartLength ]...' )
      //   if(getCartLength(prcart)>0) setlockPrCart(true)
      //   else setlockPrCart(false)
      // },[getCartLength])
  if(pagestate=='model-selection')
  return(
    <Box sx={{ flexGrow: 1 }}>
    <Grid container spacing={2}>
      {fisses.modelfisses?.map( (item,index) => (
        <Grid size={{ xs: 1, md: 3 }} key={index}>
          <Card sx={{ maxWidth: 300 }}>
                <CardMedia
                  sx={{ height: 140 }}
                  image={`${basename}/images/fiss/${item[2]}`}
                  title={`${item[0]} ${item[1]}`}
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                  {`Διαφάνειες για το ${item[0]} ${item[1]}`}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button size="small" onClick={(e) => {prepFissesofModel(item[0], item[1])} }>επιλογη</Button>
                </CardActions>
              </Card>          
        </Grid>
      ) )}
    </Grid>
    </Box>
  )
  else if(pagestate=='model-fissa-selection')
    /*  title={`${item[0]} ${item[1]}`} */
  return(
  <React.Fragment>
  <Box sx={{display: 'block'}} >Διαφάνειες του {`${modelfisses.brand} ${modelfisses.model}   `} 
    <Button size="small"  onClick={(e) => {backtoModelSelection()} }>επιστροφή</Button>
  </Box>
  <Box sx={{ flexGrow: 1 }}>
  <Grid container spacing={2}>
  {modelfisses.fisses.map( (item:any,index:any) => (
    <Grid size={{ xs: 1, md: 3 }} key={index}>
      <Card sx={{ maxWidth: 300 }}>
        <CardMedia
                  sx={{ height: 140 }}
                  image={`${item[2]}`}
                  title={`${item[1]}`}
                />
                <CardContent>
                  <Typography gutterBottom variant="h6" component="div">
                  {`${item[1]}`}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button size="small" onClick={(e) => {prepFissaImageMap(modelfisses.brand,modelfisses.model,item)} }>επιλογη</Button>
                </CardActions>
              </Card>          
    </Grid>
  ) )}
  </Grid>
  </Box>
  </React.Fragment>
  )
  else if(pagestate=='fissa-area-selection')
  return(
    <React.Fragment>
      <Box sx={{display: 'block'}} >ΔΙΑΦΑΝΕΙΑ `{`${modelfisses.brand} ${modelfisses.model} ${fissaImageMap.fissatitle} `}
      <Button size="small"  onClick={(e) => {backtoModelFisses()} }>επιστροφή</Button>
      </Box>
     <Box
      id="box-part1of-prfisses"
      sx={{
        display: 'block',
        p: 1,
        height: { xs: 200, sm: 200, md: 200 },
        width: '100%',
      }}
    >
      <div className='imagemapcontainer'>
        
       <ImageMapper ref={ref} src={fissaImageMap.imgmapurl} name={fissaImageMap.fissaid} areas={fissaImageMap.areas} isMulti={false} 
       onChange={(selectedArea, areas)=>{console.log('onChange selectedArea',selectedArea)}}
       onClick={(area, index, event)=>{console.log('onClick area',area,'index',index); 
        //let myarea:MyImageAreaType=area as MyImageAreaType;
        setPartsforBasket(area as MyImageAreaType);
        setOpenselprsdialog(true)}}
       onMouseEnter={(area, index, event)=>{
            enterArea(area)
            console.log('onMouseEnter area',area,'index',index)
        }}
        onMouseLeave={(area, index, event)=>{leaveArea();}} />

        {hoveredArea && 
    	  <span className="tooltip"
    	    style={{ ...getTipPosition(hoveredArea)}}>
    		{ hoveredArea && getImageTootiptitle(hoveredArea,fissaImageMap.areas) }
    	  </span> }

      </div>
    </Box>
    <Dialog onClose={haSelPrsDlgClose} open={openselprsdialog}>
      <DialogTitle>Επιλογή ανταλλακτικού για το καλάθι</DialogTitle>
      <List sx={{ pt: 0 }}>
        {partsforbasket?.map((part) => (
          <ListItem disablePadding key={part.prcode}>
            {/* <ListItemButton onClick={() => handleListPartClick(part)}>

              <ListItemText primary={`${part.prcode}`} secondary={`${part.prname}`} />
            </ListItemButton> */}
            <ListItemText sx={{pl:1}} primary={`${part.prcode}`} secondary={`${part.prname}`} />
            <OutlinedInput sx={{maxWidth:50, width:50}}
            id="partqty"
            autoComplete="partqty"
            placeholder="ποσότητα"
            required
            value={pravqty}
            onChange={haPrAvQtyNumberChange}
          />
            <Tooltip title="Add to Basket">
                <IconButton
                  size="small"
                  onClick={ (e)=>{
                    haAddtoBaskettPartClick(part, '1')
                  }}
                >
                  <AddShoppingCartIcon sx={{ color: '#DE0813' }} />  
                  
                </IconButton>
              </Tooltip>
          </ListItem>
        ))} 
        <ListItem disablePadding>
          <ListItemButton  sx={{ color: '#DE0813' }}
            autoFocus
            onClick={ (e)=>{haSelPrsDlgClose('close') }}
          >
                <CancelOutlinedIcon />
            <ListItemText primary="Close" />
          </ListItemButton>
        </ListItem>
      </List>
    </Dialog>
 

    </React.Fragment>
  )
  else return (<>What ?</>)
}
export default PrFisses;